import styled from "@emotion/styled";
import { Box, Card, Typography } from "@mui/material";

export const DashboardBox = styled(Box)`
  display: flex;
  align-items: center;
  flex-direction: column;
  .img {
    width: 200px;
    height: 200px;
  }
`;

export const BillingCalculationCard = styled(Card)`
  box-shadow: 5px;
  border-radius: 2px;
  margin: 10px;
  padding: 15px;
`;

export const WorkInProgressText = styled(Typography)`
  font-size: 26px;
`;
